import { render, staticRenderFns } from "./UserProfileChargeWallet.vue?vue&type=template&id=1199a6f5"
import script from "./UserProfileChargeWallet.vue?vue&type=script&lang=js"
export * from "./UserProfileChargeWallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports